import { css } from 'styled-components';

export const cnhComponentStyles = css`
  body,
  .ant-layout {
    background-color: var(--layout-body-bg-color);
  }

  .ant-layout-header {
    background-color: var(--background-color);
    border-bottom: 3px solid var(--primary-color);
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }

  .ant-card {
    background-color: var(--background-color);
    border: 1px solid var(--table-border-color);
    box-shadow: var(--box-shadow);
  }

  .ant-card-head {
    border-bottom: 2px solid var(--primary-color);
  }

  .ant-card-head-title,
  .ant-card-meta-title {
    color: var(--text-dark-color);
    font-weight: 600;
  }

  .ant-card-meta-description {
    color: var(--text-light-color);
  }

  .ant-btn {
    border-color: var(--secondary-color);
    color: var(--text-dark-color);
    font-weight: 600;
    box-shadow: none;
  }

  .ant-btn:hover,
  .ant-btn:focus {
    border-color: var(--primary-color);
    color: var(--primary-color);
  }

  .ant-btn-primary {
    color: var(--white);
    background: var(--primary-color);
    border-color: var(--primary-color);
    box-shadow: 0 2px 5px rgba(var(--primary-rgb-color), 0.28);
  }

  .ant-btn-primary:hover,
  .ant-btn-primary:focus {
    color: var(--white);
    background: var(--cnh-primary-hover-color);
    border-color: var(--cnh-primary-hover-color);
  }

  .ant-btn-primary:active {
    background: var(--black);
    border-color: var(--black);
  }

  .ant-btn-dangerous,
  .ant-btn-dangerous:hover,
  .ant-btn-dangerous:focus {
    color: var(--primary-color);
    border-color: var(--primary-color);
  }

  .ant-btn-primary.ant-btn-dangerous,
  .ant-btn-primary.ant-btn-dangerous:hover,
  .ant-btn-primary.ant-btn-dangerous:focus {
    color: var(--white);
    background: var(--primary-color);
  }

  .ant-btn-link,
  .ant-btn-text:hover,
  .ant-btn-text:focus {
    color: var(--primary-color);
  }

  .ant-btn[disabled],
  .ant-btn[disabled]:hover,
  .ant-btn[disabled]:focus,
  .ant-btn[disabled]:active {
    color: var(--disabled-color);
    background: var(--disabled-bg-color);
    border-color: var(--lightgrey);
  }

  .ant-input,
  .ant-input-affix-wrapper,
  .ant-input-number,
  .ant-picker,
  .ant-cascader-picker,
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    color: var(--text-main-color);
    background-color: var(--background-color);
    border-color: var(--lightgrey);
  }

  .ant-input:hover,
  .ant-input-affix-wrapper:hover,
  .ant-input-number:hover,
  .ant-picker:hover,
  .ant-select:not(.ant-select-disabled):hover .ant-select-selector {
    border-color: var(--secondary-color);
  }

  .ant-input[disabled],
  .ant-input-affix-wrapper-disabled,
  .ant-input-number-disabled,
  .ant-picker-disabled,
  .ant-select-disabled.ant-select:not(.ant-select-customize-input)
    .ant-select-selector {
    color: var(--disabled-color);
    background-color: var(--disabled-bg-color);
  }

  .ant-input:focus,
  .ant-input-focused,
  .ant-input-affix-wrapper-focused,
  .ant-input-number-focused,
  .ant-picker-focused,
  .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input)
    .ant-select-selector {
    border-color: var(--primary-color);
    box-shadow: 0 0 0 2px rgba(var(--primary-rgb-color), 0.18);
  }

  .ant-input-group-addon,
  .ant-input-number-group-addon {
    color: var(--text-dark-color);
    background-color: var(--cnh-surface-muted-color);
    border-color: var(--lightgrey);
  }

  .ant-select-dropdown,
  .ant-dropdown-menu,
  .ant-picker-dropdown .ant-picker-panel-container,
  .ant-cascader-menus,
  .ant-popover-inner,
  .ant-message-notice-content {
    background-color: var(--background-color);
    border: 1px solid var(--table-border-color);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.16);
  }

  .ant-select-item-option-active:not(.ant-select-item-option-disabled),
  .ant-dropdown-menu-item:hover,
  .ant-dropdown-menu-submenu-title:hover,
  .ant-cascader-menu-item:hover {
    background-color: var(--cnh-surface-muted-color);
  }

  .ant-select-item-option-selected:not(.ant-select-item-option-disabled),
  .ant-dropdown-menu-item-selected,
  .ant-cascader-menu-item-active {
    color: var(--primary-color);
    background-color: var(--cnh-primary-soft-color);
    font-weight: 600;
  }

  .ant-modal-content,
  .ant-drawer-content {
    background-color: var(--background-color);
    border: 1px solid var(--lightgrey);
    box-shadow: 0 16px 48px rgba(0, 0, 0, 0.26);
  }

  .ant-modal-header,
  .ant-drawer-header {
    background-color: var(--black);
    border-bottom: 4px solid var(--primary-color);
  }

  .ant-modal-title,
  .ant-drawer-title {
    color: var(--white);
    font-weight: 700;
  }

  .ant-modal-close,
  .ant-drawer-close {
    color: var(--lightgrey);
  }

  .ant-modal-close:hover,
  .ant-modal-close:focus,
  .ant-drawer-close:hover,
  .ant-drawer-close:focus {
    color: var(--white);
    background-color: var(--primary-color);
  }

  .ant-modal-footer,
  .ant-drawer-footer {
    background-color: var(--cnh-surface-muted-color);
    border-top: 1px solid var(--lightgrey);
  }

  .ant-modal-confirm-title,
  .ant-modal-confirm-content,
  .ant-popover-title,
  .ant-popover-inner-content {
    color: var(--text-main-color);
  }

  .ant-table {
    color: var(--text-main-color);
    background-color: var(--background-color);
    border-color: var(--table-border-color) !important;
  }

  .ant-table-container {
    border-color: var(--table-border-color) !important;
  }

  .ant-table-wrapper .ant-table-thead > tr > th {
    color: var(--black) !important;
    background-color: var(--table-header-background-color) !important;
    border-bottom: 2px solid var(--primary-color) !important;
  }

  .ant-table-wrapper .ant-table-thead > tr > th .anticon,
  .ant-table-wrapper .ant-table-filter-trigger,
  .ant-table-wrapper .ant-table-column-sorter {
    color: var(--secondary-color) !important;
  }

  .ant-table-wrapper .ant-table-filter-trigger:hover,
  .ant-table-wrapper .ant-table-filter-trigger.active {
    color: var(--primary-color) !important;
    background-color: var(--cnh-primary-soft-color);
  }

  .ant-table-wrapper .ant-table-column-sorter-up.active,
  .ant-table-wrapper .ant-table-column-sorter-down.active {
    color: var(--primary-color) !important;
  }

  .ant-table-wrapper .ant-table-thead th.ant-table-column-has-sorters:hover,
  .ant-table-wrapper .ant-table-thead th.ant-table-column-sort {
    background-color: var(--cnh-table-header-hover-color) !important;
  }

  .ant-table-tbody > tr:nth-child(even) > td {
    background-color: var(--cnh-table-stripe-color);
  }

  .ant-table-tbody > tr.ant-table-row-selected > td,
  .ant-table-tbody > tr.ant-table-row:hover > td,
  .ant-table-tbody > tr > td.ant-table-cell-row-hover {
    background-color: var(--table-hover-color) !important;
  }

  .ant-table-row-expand-icon,
  .ant-table-filter-dropdown {
    border-color: var(--secondary-color);
  }

  .ant-pagination-item,
  .ant-pagination-prev .ant-pagination-item-link,
  .ant-pagination-next .ant-pagination-item-link {
    background-color: var(--background-color);
    border-color: var(--lightgrey);
  }

  .ant-pagination-item:hover,
  .ant-pagination-prev:hover .ant-pagination-item-link,
  .ant-pagination-next:hover .ant-pagination-item-link {
    border-color: var(--primary-color);
  }

  .ant-pagination-item-active {
    background-color: var(--primary-color);
    border-color: var(--primary-color);
  }

  .ant-pagination-item-active a,
  .ant-pagination-item-active:hover a {
    color: var(--white);
  }

  .ant-tabs-tab:hover,
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: var(--primary-color);
  }

  .ant-tabs-ink-bar {
    height: 3px;
    background-color: var(--primary-color);
  }

  .ant-collapse,
  .ant-collapse-content {
    background-color: var(--background-color);
    border-color: var(--table-border-color);
  }

  .ant-collapse > .ant-collapse-item {
    border-color: var(--table-border-color);
  }

  .ant-collapse > .ant-collapse-item > .ant-collapse-header {
    color: var(--text-dark-color);
    background-color: var(--cnh-surface-muted-color);
  }

  .ant-checkbox-inner,
  .ant-radio-inner {
    border-color: var(--secondary-color);
  }

  .ant-checkbox-checked .ant-checkbox-inner,
  .ant-checkbox-indeterminate .ant-checkbox-inner::after,
  .ant-radio-inner::after,
  .ant-switch-checked {
    background-color: var(--primary-color);
    border-color: var(--primary-color);
  }

  .ant-steps-item-process .ant-steps-item-icon,
  .ant-steps-item-finish .ant-steps-item-icon {
    border-color: var(--primary-color);
  }

  .ant-steps-item-process .ant-steps-item-icon {
    background-color: var(--primary-color);
  }

  .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
    color: var(--primary-color);
  }

  .ant-steps-item-finish
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title::after {
    background-color: var(--primary-color);
  }

  .ant-progress-bg {
    background-color: var(--primary-color);
  }

  .ant-upload.ant-upload-drag {
    background-color: var(--cnh-surface-muted-color);
    border-color: var(--secondary-color);
  }

  .ant-upload.ant-upload-drag:hover,
  .ant-upload.ant-upload-drag-hover:not(.ant-upload-disabled) {
    background-color: var(--cnh-primary-soft-color);
    border-color: var(--primary-color);
  }

  .ant-upload.ant-upload-drag p.ant-upload-drag-icon .anticon,
  .ant-upload-list-item:hover .ant-upload-list-item-info {
    color: var(--primary-color);
  }

  .ant-descriptions-bordered .ant-descriptions-item-label,
  .ant-page-header,
  .ant-list-item-meta-title {
    color: var(--text-dark-color);
  }

  .ant-descriptions-bordered .ant-descriptions-item-label {
    background-color: var(--cnh-surface-muted-color);
  }

  .ant-alert-info {
    background-color: var(--cnh-primary-soft-color);
    border-color: var(--primary-color);
  }

  .ant-alert-info .ant-alert-icon,
  .ant-alert-info .ant-alert-message {
    color: var(--primary-color);
  }

  .ant-menu-item-selected,
  .ant-menu-submenu-selected > .ant-menu-submenu-title {
    color: var(--primary-color);
  }

  .ant-layout-sider .ant-menu-item-selected {
    background-color: rgba(255, 255, 255, 0.1) !important;
    border-left: 4px solid var(--primary-color);
  }

  .ant-layout-sider .ant-menu-item-selected::after {
    display: none;
  }

  .ant-layout-sider .ant-menu-item:hover,
  .ant-layout-sider .ant-menu-submenu-title:hover {
    background-color: rgba(255, 255, 255, 0.06) !important;
  }

  .ant-breadcrumb a:hover,
  .ant-back-top,
  .ant-anchor-link-active > .ant-anchor-link-title {
    color: var(--primary-color);
  }
`;
